<template>
<div class="chapter">
<div class="inner_page">
<div class="half">
<a id="page_1"></a>
<p class="half">THE GREAT CENTRAL RAILWAY</p>
<p class="subtitle">WHAT REALLY HAPPENED</p>
<a id="page_2"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Half_Title.vue?5bab267a